<template>
  <div class="container lang-dir">
    <PersonalAreaNavBar
      backurl="personal-area-mainmenu"
      :title="$t('personalArea.extAndAdds')"
    />
    <div style="padding: 15px; overflow-x: hidden">
      <!-- expalin part -->
      <PersonalAreaExtExplainOffline />
      <!-- upgrade part-->
      <div
        class="need-to-buy"
        v-if="$store.state.hasInternet && upgrades.length > 0"
        style="margin: 5px 0px 5px 0px; border: 1px solid red"
      >
        <div class="mefo-lh-120">
          <b>{{ $t("personalArea.extArea.notUpdated") }} </b>

          <p>
            {{ $t("personalArea.extArea.upgradeNow") }}
            {{ this.latestVersion || "" }}
          </p>
          <p class="price-msg">
            {{ $t("personalArea.extArea.sendToOffice") }}.
          </p>
        </div>
        <div v-for="pack in upgrades" :key="pack.Id" style="padding: 0px 10px">
          <PersonalAreaBuyUpgrade
            :name="pack.Name"
            :productKey="pack.Product_key"
            :books="pack.Num_of_books"
            :price="
              userSettings.settings['language'] == 'en' ? pack.Dollar : pack.Nis
            "
            @click="togglePackage(pack)"
            @openList="openBookList(pack)"
            :packageVersion="pack.Package_version"
          />
        </div>
      </div>
      <!-- end upgrade part-->
      <!-- mefo part -->
      <div v-if="!hasMefLicense">
        <div class="mefo-title">
          <div class="mefo-title-right">
            <span>{{ $t("general.mef") }}</span>
          </div>
          <div class="mefo-title-left" v-if="!$store.state.hasInternet">
            <Icons icon="tel" width="16px" height="16px" />
            <b>
              <span>{{ $t("personalArea.extArea.phoneAlso") }}</span></b
            >
          </div>
        </div>
      </div>
      <!-- end mefo part -->

      <div v-if="!hasMefLicense" class="mefo-main-msg-container">
        <div class="mefo-lh-120">
          <b>{{ $t("personalArea.extArea.dontHaveMef") }}</b>
        </div>
        <div class="mefo-lh-120" style="color: #a7610f">
          <b>{{ $t("personalArea.extArea.greatNews") }}</b>
        </div>
        <div class="mefo-lh-120">
          {{ $t("personalArea.extArea.mefo_explain") }}
        </div>
        <div class="mefo-inner-msg">
          <b
            ><p class="mefo-lh-120" style="color: #7b7b7b">
              {{ $t("personalArea.extArea.eyesLook") }}
            </p></b
          >
          <p class="mefo-lh-120">
            <b>{{ $t("personalArea.extArea.tryFirstPage") }}</b>
          </p>
          <p class="mefo-lh-120">
            {{ $t("personalArea.extArea.mefo_explain2") }}
          </p>
        </div>
        <div v-if="$store.state.hasInternet">
          <p class="price">
            {{
              userSettings.settings["language"] == "en"
                ? (mefItem ? mefItem.Dollar : 0) + " $"
                : (mefItem ? mefItem.Nis : 0) + " ₪"
            }}
          </p>
          <div class="price-msg">
            <p class="price-msg-label">
              {{ $t("personalArea.extArea.after_pay") }}
            </p>
            <button class="btn btn-primary" @click="togglePackage(mefItem)">
              {{ buyMef ? $t("general.cancel2") : $t("myProfile.toPurchase2") }}
            </button>
          </div>
        </div>
      </div>

      <div v-else class="has-mefo-container">
        <p style="color: black">{{ $t("general.mef") }}</p>
        <p style="color: #7b7b7b">
          {{ $t("personalArea.extArea.includeInOtzar") }}
        </p>
      </div>

      <div
        class="packs-we-have"
        :style="{ 'border-top-width': hasMefLicense ? '0px' : '1px' }"
      >
        <div style="color: #7b7b7b; font-size: 11px; line-height: 120%">
          <b
            ><p style="line-height: 120%">
              {{ $t("personalArea.extArea.machonBooks") }}
            </p></b
          >
          <p style="line-height: 120%" v-if="userPackagesArr.length > 0">
            {{ $t("personalArea.extArea.youHave") }}
          </p>
          <p style="line-height: 120%" v-else>
            {{ $t("personalArea.extArea.dontHaveAnything") }}
          </p>
        </div>

        <PersonalAreaHasPackage
          v-for="pack in userPackagesArr"
          :key="pack.Id"
          :name="pack.Name"
          :books="pack.Num_of_books"
          @openList="openBookList(pack)"
        />
      </div>
      <p class="error">{{ errorMessage1 }}</p>
      <p class="error">{{ errorMessage2 }}</p>

      <div
        class="need-to-buy"
        v-if="
          (missingPackages.length || upgrades.length) &&
          this.numItemsAvailableToPurchase > 0
        "
      >
        <span
          v-if="$store.state.hasInternet && missingPackages.length > 0"
          class="need-to-buy-title"
          >{{ $t("personalArea.extArea.buyAndUse") }}</span
        >
        <div
          v-if="!$store.state.hasInternet && missingPackages.length > 0"
          class="no-internet-buy"
        >
          <div class="mefo-title-right">
            <span>{{ $t("personalArea.extArea.buyAndUse") }}</span>
          </div>
          <div class="mefo-title-left" v-if="!$store.state.hasInternet">
            <Icons icon="tel" width="16px" height="16px" />
            <b>
              <span>{{ $t("personalArea.extArea.phoneAlso") }}</span></b
            >
          </div>
        </div>
        <!-- <div class="mefo-title-left" v-if="!$store.state.hasInternet">
          <Icons icon="tel" width="16px" height="16px" />
          <b> <span>זמין גם ברכישה טלפונית</span></b>
        </div> -->

        <div
          v-for="pack in missingPackages"
          :key="pack.Id"
          style="padding: 0px 10px"
        >
          <PersonalAreaBuyPackage
            :name="pack.Name"
            :books="pack.Num_of_books"
            :price="
              userSettings.settings['language'] == 'en' ? pack.Dollar : pack.Nis
            "
            @click="togglePackage(pack)"
            @openList="openBookList(pack)"
            v-show="!isMef(pack.Product_key) || buyMef"
            :class="{ 'mef-item': pack.Product_key == 'MEF_OTZAR' }"
            :checked="pack.Product_key == 'MEF_OTZAR'"
            :disabledPackage="pack.notAvailable"
            :packageVersion="pack.Package_version"
            :hideBooksNum="isMef(pack.Product_key)"
            :hideBookListBtn="isMef(pack.Product_key)"
          />
        </div>

        <div v-if="$store.state.hasInternet && numItemsAvailableToPurchase > 0">
          <p class="packs-price">
            {{ price.toLocaleString() }}
            {{ userSettings.settings["language"] == "en" ? "$ " : "₪ " }}
          </p>

          <div class="flex" style="align-items: center">
            <div style="display: flex; align-items: center; gap: 4px">
              <p class="price-msg">
                {{ $t("personalArea.extArea.after_pay") }}
              </p>
              <button class="btn btn-primary" @click="purchasePackages">
                {{ $t("myProfile.toPurchase2") }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <PersonalAreaTypeCode v-if="!$store.state.hasInternet" />
    <!-- <div class="type-code">
      <div class="flex">
        <span>{{ $t("personalArea.extArea.haveCode") }}</span>
        <input type="text" :placeholder="$t('personalArea.extArea.codeNum')" />
        <button
          style="color: var(--custom-color1); background-color: white"
          class="btn btn-primray"
        >
          {{ $t("general.confirm") }}
        </button>
      </div>
    </div> -->
  </div>
</template>

<script>
import Icons from "../Icons/Icons.vue";
import PersonalAreaNavBar from "./PersonalAreaNavBar.vue";
import PersonalAreaHasPackage from "./PersonalAreaHasPackage.vue";
import PersonalAreaBuyPackage from "./PersonalAreaBuyPackage.vue";
import PersonalAreaBuyUpgrade from "./PersonalAreaBuyUpgrade.vue";
import PersonalAreaExtExplainOffline from "./PersonalAreaExtExplainOffline.vue";
import init from "@/config/init.js";
import PersonalAreaTypeCode from "./PersonalAreaTypeCode.vue";
import { getAppInfo } from "@/services/offline/license.js";
import { getDiskProductsInfo, openStore } from "@/services/purchase";
import { mapState } from "vuex";
import { createBookListByVersion } from "@/services/bookLists";
import Axios from "axios";
export default {
  data() {
    return {
      packagesData: [],
      userPackagesArr: [],
      missingPackages: [],
      upgrades: [],
      packagesToPurchase: [],
      mefLic: false,
      version: 0,
      price: 0,
      currency: 'ש"ח',
      errorMessage1: "",
      errorMessage2: "",
      latestVersion: 0,
      licensePackages: {},
    };
  },
  components: {
    PersonalAreaTypeCode,
    PersonalAreaNavBar,
    PersonalAreaExtExplainOffline,
    Icons,
    PersonalAreaHasPackage,
    PersonalAreaBuyPackage,
    PersonalAreaBuyUpgrade,
  },
  computed: {
    ...mapState("user", ["licenseInfo"]),
    hasMefLicense() {
      let userLicensePackages = this.licenseInfo.packages;
      if (userLicensePackages == 0) return false;
      return userLicensePackages & this.licensePackages.MEF_OTZAR;
    },
    buyMef() {
      return this.packagesToPurchase.find((p) => p.Product_key == "MEF_OTZAR");
    },
    buyUpgrade() {
      return this.packagesToPurchase.find((p) => p.Product_level == 5);
    },
    mefItem() {
      return this.packagesData.filter((p) => p.Product_key == "MEF_OTZAR")[0];
    },
    numItemsAvailableToPurchase() {
      return !this.hasMefLicense &&
        this.missingPackages.length == 1 &&
        this.packagesToPurchase.length == 0 &&
        this.upgrades.length == 0
        ? 0
        : this.missingPackages.length +
            this.upgrades.length +
            this.packagesToPurchase.length;
    },
    showOzNewMessage() {
      return !globalThis.OTZAR_BASIC_INFO.hasOzNewBooks;
    },
    async isOzNewPackageAvailable() {
      let available = false;
      delete Axios.defaults.headers.common["Authorization"];
      const oz_newUrl =
        "https://storage.googleapis.com/otzar_updates/oz/oz1.zip";
      try {
        await Axios.head(oz_newUrl);
        available = true;
      } catch (ex) {
        console.log(ex);
      }

      return available;
    },
  },
  methods: {
    addAdditionalPackages() {
      //add OTZAR_MEFHARSHI_HATLMOD if needed
      const otzarMefarsheiHatalmudItem = this.packagesData.find(
        (p) => p.Product_key == "OTZAR_MEFHARSHI_HATLMOD"
      );

      if (
        otzarMefarsheiHatalmudItem &&
        this.packagesToPurchase.find((p) => p.Product_key == "MACHON")
      )
        this.packagesToPurchase.push(otzarMefarsheiHatalmudItem);

      //add new oz if needed
      const ozNewItem = this.packagesData.find(
        (p) => p.Product_key == "OZ_NEW"
      );

      if (
        ozNewItem &&
        this.packagesToPurchase.find((p) => p.Product_key == "OZ")
      )
        this.packagesToPurchase.push(ozNewItem);
    },
    isMef(prod_key) {
      return prod_key == "MEF_OTZAR";
    },
    async togglePackage(packageData) {
      this.errorMessage1 = "";
      this.errorMessage2 = "";
      let price =
        this.userSettings.settings["language"] == "en"
          ? packageData.Dollar
          : packageData.Nis;

      if (
        this.packagesToPurchase.find(
          (p) => p.Product_key == packageData.Product_key
        )
      ) {
        this.packagesToPurchase = this.packagesToPurchase.filter(
          (p) => p.Product_key != packageData.Product_key
        );
        let pack = this.missingPackages.find((p) => p.Name == packageData.Name);
        if (pack || packageData.Product_level != 2) {
          this.price -= price;
        }
      } else {
        //show attention message for oz_new
        const packAvailable = await this.isOzNewPackageAvailable;
        if (
          packAvailable &&
          this.showOzNewMessage &&
          (packageData.Product_key == "OZ" ||
            packageData.Product_key == "OZ_NEW")
        )
          await this.$msg({
            content:
              "לאחר הרכישה יש להפעיל מחדש את התוכנה ולפעול על פי ההוראות להורדת ספרי עוז והדר החדשים ",
            title: this.$t("general.attention"),
            btns: [this.$t("general.confirm")],
          });
        if (packageData.Product_level == 5)
          packageData.Name = `${this.$t(
            "personalArea.extArea.versionUpgrade"
          )} >> ${packageData.Product_key}`;
        this.packagesToPurchase.push(packageData);
        let pack = this.missingPackages.find((p) => p.Name == packageData.Name);
        if (pack || packageData.Product_level != 2) {
          this.price += price;
        }
      }
    },
    async purchasePackages() {
      this.errorMessage1 = "";
      this.errorMessage2 = "";

      let products = this.packagesToPurchase.map((p) => p.Product_key);
      let URL = await openStore({
        SN: this.licenseInfo.serialNumber,
        products,
        details: this.packagesToPurchase.map((p) => p.Name),
        lang: this.userSettings.settings["language"] || "he",
      });
      if (URL) window.open(URL);
      else {
        this.errorMessage1 = this.$t("mefo.purchaseMefError1");
        this.errorMessage2 = this.$t("mefo.purchaseMefError2");
      }
    },
    async openBookList(pack) {
      const packagesToGet = [pack.Product_key];
      if (pack.Product_key == "OZ" && pack.expanded)
        packagesToGet.push("OZ_NEW");
      if (pack.Product_key == "MACHON" && pack.expanded)
        packagesToGet.push("OTZAR_MEFHARSHI_HATLMOD");

      const data = await createBookListByVersion(packagesToGet, this.version);
      if (data) window.open(data);
      else
        await this.$msg({
          title: this.$t("general.error"),
          content: "לא נמצאו נתונים ליצירת הרשימה",
          btns: [this.$t("general.confirm")],
        });
    },
  },
  async mounted() {
    if (globalThis.SERVER_MODE == "online") return;
    getAppInfo(false)
      .then(async (res) => {
        if (res) {
          if (typeof res === "number") {
            this.licenseType =
              (errorsMgr.errorCodes[res - 1] || "UNKNOWN") +
              " " +
              this.$t("errors.code") +
              " " +
              res;
            this.expireDate = "";
            this.version = "";
            this.packageData = "NA";
            return;
          }
          this.updateVer = res.updatesVer;
          this.licenseType = res.LicType;
          this.expireDate = res.Day + "/" + res.Month + "/" + res.Year;
          this.version = res.otzarVer;
          this.packageData = res.packages;
          this.mefotzarLicence = res.mefotzarLicence;

          //get products data from office
          let productsData = await getDiskProductsInfo();
          if (!Array.isArray(productsData)) {
            this.noProductsData = true;
            productsData = [
              { Product_key: "CHABAD", Name: 'חב"ד' },
              { Product_key: "KOOK", Name: "מוסד הרב קוק" },
              { Product_key: "MACHON", Name: "מכון ירושלים" },
              { Product_key: "SHLOMO", Name: "מכון חכמת שלמה" },
              { Product_key: "SHALOM", Name: "מכון אהבת שלום" },
              { Product_key: "OFEK", Name: "מכון אופק" },
              { Product_key: "OZ", Name: "עוז והדר" },
              { Product_key: "ENC", Name: "האנציקלופדיה התלמודית" },
              { Product_key: "MEF_OTZAR", Name: "מפרשי האוצר" },
              { Product_key: "AHARON", Name: "זכרון אהרן" },
              {
                Product_key: "OTZAR_MEFHARSHI_HATLMOD",
                Name: "אוצר מפרשי התלמוד",
              },
              {
                Product_key: "OVADIA",
                Name: "מאור ישראל",
              },
              {
                Product_key: "YESHARIM",
                Name: "אור לישרים",
              },
              {
                Product_key: "OZ_NEW",
                Name: "עוז והדר חדש",
              },
              {
                Product_key: "LUCHOT",
                Name: 'לוחות שנה תשפ"ה',
              },
            ];

            this.licensePackages = init.licensePackages;
          }
          try {
            const numOfBooksData = await createBookListByVersion(
              [0],
              this.version,
              true
            );
            const numOfBooksDataMap = new Map(
              numOfBooksData.map((obj) => [obj.title, obj.count])
            );

            productsData.forEach((product) => {
              product.Num_of_books =
                numOfBooksDataMap.get(product.Product_key) ||
                product.Num_of_books;
            });

            this.packagesData = productsData;
          } catch (ex) {
            console.log(
              `Error getting number of books for each package >> ${ex.message}`
            );
          }

          if (!this.noProductsData) {
            let lic = Object.fromEntries(
              productsData
                .filter((p) => p.Product_level == 2)
                .map((p) => [p.Product_key, p.UserRightID])
            );

            this.licensePackages = lic;

            this.upgrades = productsData.filter(
              (p) =>
                p.Product_level == 5 &&
                p.Active &&
                p.Package_version == this.version
            );

            try {
              if (this.upgrades[0])
                this.latestVersion = this.upgrades[0].Product_key.split("-")[1];
            } catch {}

            this.packagesData = productsData.filter(
              (p) => p.Product_level == 2
            );

            try {
              let _t = this;

              let mp = [],
                up = [];
              let pack = this.packageData;

              for (let i = 0; i < this.packagesData.length; i++) {
                let productData = this.packagesData[i];

                const packCode =
                  // init.licensePackages[productData["Product_key"]];
                  this.licensePackages[productData["Product_key"]];
                const packExists = pack & packCode;
                if (packExists != packCode) {
                  if (
                    productData.Package_version &&
                    productData.Package_version > this.version
                  )
                    productData.notAvailable = true;

                  if (productData.Product_key == "MEF_OTZAR")
                    mp.unshift(productData);
                  else mp.push(productData);
                } else {
                  if (packExists == packCode) up.push(productData);
                }
              }

              //if machon and OTZAR_MEFHARSHI_HATLMOD exist - show number of books of both
              const machonBooksMissing = mp.find(
                (p) => p.Product_key == "MACHON"
              );
              const mefarsheiBooksMissing = mp.find(
                (p) => p.Product_key == "OTZAR_MEFHARSHI_HATLMOD"
              );

              if (machonBooksMissing && mefarsheiBooksMissing) {
                machonBooksMissing.Num_of_books +=
                  mefarsheiBooksMissing.Num_of_books;
                machonBooksMissing.expanded = true;
              }

              //if I dont have MACHON - filter out OTZAR_MEFHARSHI_HATLMOD because it is included in MACHON
              if (mp.find((p) => p.Product_key == "MACHON"))
                mp = mp.filter(
                  (p) => p.Product_key != "OTZAR_MEFHARSHI_HATLMOD"
                );

              //if oz and oz_new exist - show number of books of expanded oz
              const OzBooksMissing = mp.find((p) => p.Product_key == "OZ");
              const newOzBooksMissing = mp.find(
                (p) => p.Product_key == "OZ_NEW"
              );

              if (OzBooksMissing && newOzBooksMissing) {
                OzBooksMissing.Num_of_books += newOzBooksMissing.Num_of_books;
                OzBooksMissing.expanded = true;
              }

              //if  OZ is missing - filter out OZ_NEW because it is included in OZ
              if (mp.find((p) => p.Product_key == "OZ"))
                mp = mp.filter((p) => p.Product_key != "OZ_NEW");

              mp = mp.filter((p) => p.Active);

              //if oz and oz_new exist - show number of books of expanded oz
              const OzBooks = up.find((p) => p.Product_key == "OZ");
              const newOzBooks = up.find((p) => p.Product_key == "OZ_NEW");

              if (OzBooks && newOzBooks) {
                OzBooks.Num_of_books += newOzBooks.Num_of_books;
                OzBooks.expanded = true;
              }

              //dont display oz_new and mef in  packages that user has already
              up = up.filter(
                (p) => p.Product_key != "MEF_OTZAR" && p.Product_key != "OZ_NEW"
              );
              this.missingPackages = mp;
              this.userPackagesArr = up;
            } catch (ex) {
              console.log(ex);
            }
          }
        }
      })
      .catch((err) => {
        console.error(err);
      });
  },
};
</script>

<style lang="scss" scoped>
.container {
  overflow-x: hidden;
  display: flex;
  flex-direction: column;
}
.mefo-inner-msg {
  border-radius: 5px;
  background: rgba(0, 0, 0, 0.05);
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 8px 10px;
}
.mefo-main-msg-container * {
  margin: 0px;
}
.mefo-main-msg-container {
  padding: 15px;
  border-radius: 5px;
  background: #ebebeb;
  display: flex;
  gap: 10px;
  flex-direction: column;
  margin-bottom: 15px;
}
.mefo-title {
  display: flex;
  padding: 15px 0px;
  padding-top: 0px;
}
.mefo-title-right {
  flex-grow: 1;
  color: #7b7b7b;
  font-weight: 700;
  font-size: 11px;
  line-height: 120%;
  display: flex;
  align-items: center;
}
.mefo-lh-120 {
  line-height: 120%;
}
.mefo-title-left {
  color: #a7610f;
  stroke: #a7610f;
  stroke-width: 0.6px;
  display: flex;
  align-items: center;
  gap: 5px;
}
.price {
  color: #000;
  font-weight: 700;
  font-size: 13px;
}
.price-msg {
  display: flex;
  justify-content: space-between;
}
.price-msg-label {
  color: #7b7b7b;
  font-size: 11px;
  font-style: normal;
  font-weight: 400;
  line-height: 120%;
}

.has-mefo-container {
  padding: 15px 10px;
  line-height: 120%;
  border-bottom: 1px solid #dedede;
  border-top: 1px solid #dedede;
  margin: 15px 0px;
  padding-top: 0px;
  border-top-width: 0px;
  margin-top: 0px;
}
.has-mefo-container p {
  margin: 0px;
}
.packs-we-have {
  padding: 0px 10px;
  padding-bottom: 15px;
  padding-top: 15px;
  border-top: 1px solid #dedede;
}
.packs-we-have p {
  margin: 0px;
}
.need-to-buy {
  background: #ebebeb;
  border-radius: 5px;
  display: flex;
  padding: 10px;
  flex-direction: column;
  justify-content: center;
  gap: 3px;
  align-self: stretch;
}
.need-to-upgrade {
  background: lightgrey;
  border-radius: 5px;
  display: flex;
  padding: 10px;
  flex-direction: column;
  justify-content: center;
  gap: 10px;
  align-self: stretch;
}
.need-to-buy-title {
  color: #7b7b7b;
  font-size: 11px;
  font-style: normal;
  font-weight: 700;
  line-height: 120%;
  padding-bottom: 7px;
}
.packs-price {
  color: #000;
  font-size: 13px;
  font-style: normal;
  font-weight: 700;
  line-height: 120%;
}
.price-msg {
  color: #7b7b7b;
  font-size: 11px;
  font-style: normal;
  font-weight: 400;
  line-height: 120%;
  align-items: center;
  gap: 4px;
}
.no-internet-buy {
  display: flex;
  line-height: 125%;
  font-size: 11px;
  gap: 10px;
  padding-bottom: 8px;
}
.type-code {
  display: none;
  position: sticky;
  bottom: 0px;
  background-color: var(--custom-color1);
  padding: 15px 10px;
  color: white;
  line-height: 120%;
}
.error {
  color: red;
}
.mef-item {
  border: 1px solid red;
}
</style>
